<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-10 offset-lg-1 mt-4">
                    <div class="intro col-12 col-md-8">
                        <h2 class="mb-2">
                            Mijn scholen
                        </h2>
                        <slot name="introductionText"></slot>
                    </div>

                    <div v-if="profile != {} && schools != {}">
                        <template>
                            <v-data-table
                                dense
                                :headers="headers"
                                :items="schools"
                                disable-pagination
                                class="elevation-1 col-12"
                            >
                                <template v-slot:item="row">
                                    <tr>
                                        <td>{{ row.item.SchoolName }}</td>
                                        <td>
                                            {{ row.item.SchoolMunicipality }}
                                        </td>
                                        <td>
                                            €
                                            {{
                                                row.item.Cashbook.totalRemainder
                                            }}
                                        </td>
                                        <td>
                                            €
                                            {{
                                                row.item.Cashbook.totalExpenses
                                            }}
                                        </td>
                                        <td>
                                            <button
                                                class="button button--default button--blue-7 button--small"
                                                @click="
                                                    impersonate(
                                                        row.item.SchoolName,
                                                        row.item.Email
                                                    )
                                                "
                                            >
                                                <span>
                                                    Ga naar
                                                    <i
                                                        class="fas ml-2 fa-arrow-right"
                                                    ></i>
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </template>
                    </div>

                    <dashboardMessage
                        :type="loading"
                        :message="responseMsg"
                        :process="processing"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';

export default {
    components: {
        dashboardMessage
    },
    props: {
        user: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            responseMsg: '',
            processing: false,
            loading: false,
            profile: {},
            schools: [],
            headers: [
                { text: 'Naam school', value: 'SchoolName' },
                { text: 'Gemeente', value: 'SchoolMunicipality' },
                { text: 'Totaal budget', value: 'Cashbook.totalEarnings' },
                { text: 'Totaal uitgaven', value: 'Cashbook.totalExpenses' },
                { text: '', value: 'action' }
            ]
        };
    },
    created() {
        this.profile = JSON.parse(this.user);
    },
    mounted() {
        this.schools = this.profile.Schools;
    },
    methods: {
        impersonate(name, email) {
            this.responseMsg = 'Gegevens ophalen';
            this.loading = true;
            axios
                .post('/api/ClientDashBoardImpersonateAPI/Impersonate', {
                    SchoolName: name,
                    Email: email
                })
                .then(response => {
                    if (response.data.success) {
                        this.responseMsg =
                            'Een moment geduld, je word doorgestuurd naar de scholenpagina';
                        window.location.replace(response.data.redirectUrl);
                    } else {
                        this.responseMsg = '';
                        this.loading = false;
                        this.loginError = true;
                    }
                    return;
                })
                .catch(e => {
                    this.responseMsg = '';
                    this.loading = false;
                    this.errors.push(e);
                });
        }
    }
};
</script>
<style></style>
